/**
 * Rental klón („utolsó bérlés kosár") API-kliens (FE-A4, Wave-2 / E-105 Phase 3).
 *
 * A `GET /rentals/last?partnerId` a partner legutóbbi bérlésének line-item
 * kosarát adja vissza (BE-3) — az FE-A4 „Ugyanaz mint múltkor" CTA innen
 * hydrate-eli a wizard-store-t. `null` → a partnernek nincs korábbi bérlése.
 */
import type { LastRentalCart } from '@kgc/api-contract';
import { api } from './client';

export async function getLastRentalCart(partnerId: string): Promise<LastRentalCart | null> {
  const response = await api.get<{ data: LastRentalCart | null }>(
    `/rentals/last?partnerId=${partnerId}`
  );
  return response.data;
}
